export const API_ROUND_ENROLMENTS_COUNTS_INDEX = 'API_ROUND_ENROLMENTS_COUNTS_INDEX'
export const API_ROUND_ENROLMENTS_COUNTS_SET_ALL_FILTERS = 'API_ROUND_ENROLMENTS_COUNTS_SET_ALL_FILTERS'

export const setAllFilters = (filters: any) => ({
  type: API_ROUND_ENROLMENTS_COUNTS_SET_ALL_FILTERS,
  ...filters,
})
